import React from "react";
import { ReviewsViewerSSR } from "tsi-common-react/src/apps/reviews/ReviewsViewerSSR/index";

import { templates } from "@reactivated";

export const Template = (
    props: templates.ReviewsPageTemplate,
): React.JSX.Element => {
    return (
        <ReviewsViewerSSR
            {...props}
            // #30638: the server already sends show_sources false for
            // stearns. That flag used to switch off the product links and pin
            // the list to one source as well, so no sourceFilterWhitelist here
            // (every review stays) and enablePDPLinks turns the links back on.
            enablePDPLinks={true}
        />
    );
};
